export default __webpack_public_path__ + "i18n/translations/translation-cs.82f13758.json";